import { t } from 'localization/utils/t';

const TP = 'checkout.utils.localizeShippingMethod';

export const localizeShippingMethod = (text: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'standard':
      return t(`${TP}.standard`, 'Standard');
    case 'standard (instant)':
      return t(`${TP}.standardInstantship`, 'Standard (Instant)');
    case 'expedited':
      return t(`${TP}.expedited`, 'Expedited');
    case 'next day':
      return t(`${TP}.nextDay`, 'Next Day');
    case 'next day (instant)':
      return t(`${TP}.nextDayInstant`, 'Next Day (Instant)');
    default:
      return text;
  }
};
